export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/262692505551"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-green-500 text-white shadow-lg hover:scale-110 transition-transform duration-300"
      aria-label="WhatsApp"
    >
      <i className="ri-whatsapp-line w-7 h-7 flex items-center justify-center text-2xl" />
    </a>
  );
}